import { ReasonCode } from "@/lib/api/risk/brokerage/tt/v2";

export const REASON_LABELS: Record<ReasonCode, string> = {
  missing_customer: "Missing Customer",
  missing_order_type: "Missing Order Type",
  missing_otc_type: "Missing OTC Type",
  missing_crop_year: "Missing Crop Year",
};

/** Uniform amber for all four reasons (per spec). */
export const REASON_BADGE_CLASS =
  "bg-amber-100 text-amber-800 border-amber-200";
